import { app } from '@/main';

export function useMatomo() {
  const matomo = app.config.globalProperties.$matomo;

  return { matomo };
}
